import React from "react";
import { Instagram, Youtube, Mail, MapPin, Music2, Send, MessageCircle } from "lucide-react";
import { useLang } from "@/context/LangContext";

const WHATSAPP = "https://wa.me/4917656759019";
const TELEGRAM = "https://t.me/elite_player_coach";

export default function ContactPage() {
    const { t } = useLang();
    return (
        <div data-testid="contact-page" className="px-6 md:px-12 lg:px-20 py-16 max-w-6xl mx-auto">
            {/* HEADER */}
            <div className="mb-10">
                <div className="font-body text-xs uppercase tracking-[0.25em] text-volt mb-3">
                    {t("contact_title")}
                </div>
                <h1 className="text-5xl md:text-6xl font-heading uppercase leading-none">
                    Elite Player Academy
                </h1>
                <p className="mt-5 text-white/70 text-sm md:text-base max-w-2xl">
                    {t("contact_body")}
                </p>
            </div>

            {/* EXPLORE (full width) */}
            <div className="border border-white/10 bg-zinc-900 p-8 mb-10 max-w-3xl mx-auto">
                <div className="font-heading text-volt tracking-widest text-sm mb-6 text-center">
                    {t("explore").toUpperCase()}
                </div>
                <ul className="grid grid-cols-2 sm:grid-cols-3 gap-3 text-white/85 font-heading uppercase text-base tracking-wider text-center">
                    <li><a href="/" className="hover:text-volt">{t("nav_home")}</a></li>
                    <li><a href="/programs" className="hover:text-volt">{t("nav_programs")}</a></li>
                    <li><a href="/trainings" className="hover:text-volt">{t("nav_trainings")}</a></li>
                    <li><a href="/reviews" className="hover:text-volt">{t("nav_reviews")}</a></li>
                    <li><a href="/contact" className="hover:text-volt">Contact us</a></li>
                </ul>
            </div>

            {/* SOCIAL MEDIA / CONNECT */}
            <div className="border border-white/10 bg-zinc-900 p-8 md:p-10">
                <div className="text-center mb-8">
                    <div className="font-heading text-volt tracking-widest text-sm">
                        {t("social_connect").toUpperCase()}
                    </div>
                </div>
                <div className="grid grid-cols-2 gap-3 max-w-2xl mx-auto">
                    {[
                        { label: "INSTAGRAM", href: "https://www.instagram.com/elite_player_academy", Icon: Instagram },
                        { label: "TIKTOK",    href: "https://www.tiktok.com/@elite_player_academy",  Icon: Music2 },
                        { label: "YOUTUBE",   href: "https://youtube.com/@eliteplayeracademy",       Icon: Youtube },
                        { label: "EMAIL",     href: "mailto:eliteplayeracademy1@gmail.com",           Icon: Send },
                    ].map(({ label, href, Icon }) => (
                        <a key={label} href={href} target="_blank" rel="noreferrer"
                           data-testid={`social-${label.toLowerCase()}`}
                           className="btn-ghost-outline px-4 py-4 text-sm inline-flex items-center justify-center gap-2">
                            <Icon size={14} /> {label}
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
}
